import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error) {
    console.error("ErrorBoundary caught error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-card rounded-xl shadow-lg p-5 border border-destructive">
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-destructive mb-1">
                Something went wrong
              </h3>
              <p className="text-xs text-muted-foreground">
                Partnership discovery temporarily unavailable. Please refresh the page and try again.
              </p>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
